module.exports = __webpack_public_path__ + "static/media/receta-22.26de37af.png";